/** Candidats extraits du Messenger du 26 sept. 2026. Rien n'est créé tant que Marcel n'approuve pas. */
export const TASK_CANDIDATES = [
  {
    id: "cand_nordquest",
    proposedTitle: "Préparer la carte NordQuest et l'installer sur les cellulaires",
    assigneeId: "mem_marcel",
    author: "Marcel Charette",
    when: "23 sept. 2026",
    confidence: "élevée",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "De mon côté, je vais préparer notre nouvelle carte NordQuest avec ces points déjà dessus. Ensuite, on va l'installer sur tous nos cellulaires.",
  },
  {
    id: "cand_boucherie",
    proposedTitle: "Appeler une boucherie avant le départ",
    assigneeId: "mem_eric",
    author: "Éric",
    when: "25 sept. 2026",
    confidence: "moyenne",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "Pour le Boucher on fait quoi et qui il faut appeler une Boucherie avant de partir",
    note: "Formulation ambiguë. Ne pas en faire une tâche. Après une récolte, c’est Steve qui contacte la Boucherie Allard. Pas d’appel avant le départ.",
  },
  {
    id: "cand_luc_gear",
    proposedTitle: "Apporter huile, scie à chaîne, Blade Sawzall, vin et rye",
    assigneeId: "mem_luc",
    author: "Chantal",
    when: "26 sept. 2026",
    confidence: "moyenne",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "Luc — hamburg steak, patate, sauce au poivre, viande d'orignal, choux de Bruxelles, oignon, huile, Blade saw all, vin, rye au mûre, scie à chaîne",
    note: "Le souper de Luc est déjà au menu. Ce message mélange le repas et du matériel.",
  },
  {
    id: "cand_desserts",
    proposedTitle: "Vérifier les desserts de Daniel",
    assigneeId: "mem_marcel",
    author: "Robin Chartrand",
    when: "26 sept. 2026",
    confidence: "élevée",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "Daniel apporte les desserts, carrés au sirop d'érable, petits cornets pour Luc, guimauve au chocolat, Rocky road, sac de nuts and bolts, et biscuits à venir",
    note: "Déjà listé dans Repas. Approuver seulement si un rappel est utile.",
  },
  {
    id: "cand_permis_steve",
    proposedTitle: "Acheter le permis d'orignal, zone 27",
    assigneeId: "mem_steve",
    author: "Steve St-Laurent",
    when: "16 sept. 2026",
    confidence: "à confirmer",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "J'attends mon chèque avant d'acheter mon permis",
    note: "Peut déjà être fait.",
  },
  {
    id: "cand_permis_pierre",
    proposedTitle: "Acheter le permis d'entrée",
    assigneeId: "mem_pierre",
    author: "Pierre Bertrand",
    when: "16 sept. 2026",
    confidence: "à confirmer",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "il me reste juste mon permis à entrée comme info, vas aller acheter la semaine prochaine",
    note: "Peut déjà être fait.",
  },
  {
    id: "cand_carabine",
    proposedTitle: "Décider si la carabine 270 de rechange part",
    assigneeId: "mem_steve",
    author: "Steve St-Laurent",
    when: "2 sept. 2026",
    confidence: "faible",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "Eric apporter vous une carabine de spare si oui j'ai ma 270 que je peux apporter",
  },
  {
    id: "cand_cordes",
    proposedTitle: "Préparer les cordes pour suspendre l'orignal",
    assigneeId: "mem_steve",
    author: "Steve St-Laurent",
    when: "18 juil. 2026",
    confidence: "moyenne",
    source: "Messenger — Chasse Port-Neuf 2026",
    original: "êtes-vous intéressés par des cordes que je fais pour suspendre à l'orignal si oui je vais en préparer",
  },
];
